import { Link } from "react-router-dom";
import { IconArrowLeft } from "./BenchmarkIcons";

export const installationGuideSteps = [
  {
    id: "download",
    number: "STEP 1",
    title: "Download the APK",
    description:
      "Open the app page on OpenAppCart and tap Download APK to save the file to your device.",
  },
  {
    id: "permission",
    number: "STEP 2",
    title: "Allow Installation Permission",
    description:
      "Android may ask you to allow installation from the browser or source you used. This Install unknown apps setting is a standard Android security permission — enable it only when you trust the app and source.",
  },
  {
    id: "install",
    number: "STEP 3",
    title: "Install the App.",
    description:
      "Open the downloaded APK, tap Install, wait for Android to finish, then tap Open to launch the app.",
  },
] as const;

type AppInstallationGuideStepsSectionProps = {
  showBackLink?: boolean;
};

export function AppInstallationGuideStepsSection({
  showBackLink = false,
}: AppInstallationGuideStepsSectionProps) {
  return (
    <>
      <header className="oac-installation-steps-page__header">
        <p className="oac-installation-steps-page__intro">
          Follow these three steps to install an Android app from OpenAppCart.
        </p>
      </header>

      <div className="oac-installation-steps-page__steps-grid">
        {installationGuideSteps.map((step) => (
          <section
            aria-labelledby={`oac-installation-step-${step.id}`}
            className="oac-installation-steps-page__section"
            key={step.id}
          >
            <p className="oac-installation-steps-page__step-label">{step.number}</p>

            <h2
              className="oac-installation-steps-page__section-title"
              id={`oac-installation-step-${step.id}`}
            >
              {step.title}
            </h2>

            <p className="oac-installation-steps-page__description">
              {step.description}
            </p>
          </section>
        ))}
      </div>

      {showBackLink ? (
        <p className="oac-installation-steps-page__back">
          <Link
            aria-label="Back to App Installation Guide"
            className="oac-installation-steps-page__back-link"
            onClick={(event) => {
              if (
                typeof window === "undefined" ||
                !window.matchMedia("(max-width: 67.9375rem)").matches
              ) {
                return;
              }

              event.preventDefault();

              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

              const scroller = document.querySelector(".oac-scrollable-main");
              if (scroller instanceof HTMLElement) {
                scroller.scrollTo({ top: 0, left: 0, behavior: "smooth" });
              }
            }}
            title="Back to App Installation Guide"
            to="/app-installation-guide"
          >
            <IconArrowLeft
              className="oac-installation-steps-page__back-icon"
              size={40}
            />
          </Link>
        </p>
      ) : null}
    </>
  );
}
